const key = {
  ENV_DEFAULT_KEY: process.env.PORTAL_ROOT_ENVIRONMENT || 'default_env',
  DEPLOY_PATH: 'portal_deploy_path',
};

const apis = {
  apisEndpoints: {
    default_env: {
      ORDERS_API_URL_SERVER: 'https://lehed.delfi.ee/api/cxense/v1/orders',
      ORDERS_API_URL: 'https://lehed.delfi.ee/api/cxense/v1/orders',
      ARTICLE_EXTRA_CONTENT_API_URL_SERVER: 'https://www.delfi.ee/misc/common/pc/article_extra.php',
      ARTICLE_EXTRA_CONTENT_API_URL: 'https://www.delfi.ee/misc/common/pc/article_extra.php',
      CONFIG_API_URL_SERVER: 'https://www.delfi.ee/misc/common/pc/config.php',
      CONFIG_API_URL: 'https://www.delfi.ee/misc/common/pc/config.php',
      FEED_API_URL_SERVER: 'https://www.delfi.ee/misc/common/pc/feed_v3.php',
      FEED_API_URL: 'https://www.delfi.ee/misc/common/pc/feed_v3.php',
      CONTENT_API_URL_SERVER: 'http://content-api-graphql.content-api/content/v2',
      CONTENT_API_URL_V3: 'https://api.delfi.ee/content/v3',
      CONTENT_API_URL_V3_SERVER: 'https://api.delfi.ee/content/v3',
      MEDIA_API_URL_SERVER: 'https://api.delfi.ee/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://api.delfi.ee/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://api.delfi.ee/media/v1',
      MEDIA_API_DATA_URL: 'https://api.delfi.ee/media/v1',
      PAYWALL_API_URL_SERVER: 'http://paywall-api-internal.paywall-api/paywall/v1',
      PAYWALL_API_URL: 'https://api.delfi.ee/paywall/v1',
      LOGIN_API_URL_SERVER: 'http://login-api-v2-internal.login-api/login/v2',
      LOGIN_API_CLIENT_URL: 'https://lt-production-login-api-client.s3-website.teliahybridcloud.com/test.js',
      LOGIN_APP_BASE_URL: 'https://static.delfi.net/login/master/review',
      PCC_API_URL_SERVER: 'https://old.delfi.ee/pcc-api/v1',
      CUSTOMER_DATA_API_URL: 'https://api.delfi.ee/customer-data/v2',
      WEATHER_API_URL_SERVER: 'https://api.delfi.lt/weather/v1/graphql',
      WEATHER_API_URL: 'https://api.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: 'https://lt-production-portal-root.s3.delfi.net',
    },
    lt_test: {
      ORDERS_API_URL_SERVER: '',
      ORDERS_API_URL: '',
      ARTICLE_EXTRA_CONTENT_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/article_extra.php',
      ARTICLE_EXTRA_CONTENT_API_URL: 'https://www.delfi.lt/misc/pc/article_extra.php',
      CONFIG_API_URL_SERVER: 'https://www.hamlet.delfi.lt/misc/pc/config.php',
      CONFIG_API_URL: 'https://www.hamlet.delfi.lt/misc/pc/config.php',
      FEED_API_URL_SERVER: 'https://www.hamlet.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.hamlet.delfi.lt/misc/pc/feed.php',
      CONTENT_API_URL_SERVER: 'http://content-api-graphql.content-api/content/v2',
      CONTENT_API_URL_V3: 'https://api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'https://api.delfi.lt/content/v3',
      MEDIA_API_URL_SERVER: 'https://api.test.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://api.test.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://api.test.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://api.test.delfi.lt/media/v1',
      PAYWALL_API_URL_SERVER: 'http://paywall-api-internal.paywall-api/paywall/v1',
      PAYWALL_API_URL: 'https://api.delfi.lt/paywall/v1',
      LOGIN_API_URL_SERVER: 'https://api.test.delfi.lt/login/v2',
      LOGIN_API_CLIENT_URL: 'https://lt-production-login-api-client.s3-website.teliahybridcloud.com/test.js',
      LOGIN_APP_BASE_URL: 'https://static.delfi.net/login/master/test',
      PCC_API_URL_SERVER: '',
      CUSTOMER_DATA_API_URL: 'https://api.test.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'https://api.test.delfi.lt/weather/v1/graphql',
      WEATHER_API_URL: 'https://api.test.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || 'https://lt-test-portal-root.s3.delfi.lt',
    },
    lt_review: {
      ORDERS_API_URL_SERVER: '',
      ORDERS_API_URL: '',
      ARTICLE_EXTRA_CONTENT_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/article_extra.php',
      ARTICLE_EXTRA_CONTENT_API_URL: 'https://www.delfi.lt/misc/pc/article_extra.php',
      CONFIG_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/config.php',
      CONFIG_API_URL: 'https://www.delfi.lt/misc/pc/config.php',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      CONTENT_API_URL_SERVER: 'http://content-api-graphql.content-api/content/v2',
      CONTENT_API_URL_V3: 'https://api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'https://api.delfi.lt/content/v3',
      MEDIA_API_URL_SERVER: 'https://api.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://api.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://api.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://api.delfi.lt/media/v1',
      PAYWALL_API_URL_SERVER: 'http://paywall-api-internal.paywall-api/paywall/v1',
      PAYWALL_API_URL: 'https://api.delfi.lt/paywall/v1',
      LOGIN_API_URL_SERVER: 'https://api.test.delfi.lt/login/v2',
      LOGIN_API_CLIENT_URL: 'https://lt-production-login-api-client.s3-website.teliahybridcloud.com/test.js',
      LOGIN_APP_BASE_URL: 'https://static.delfi.net/login/master/test',
      PCC_API_URL_SERVER: '',
      CUSTOMER_DATA_API_URL: 'https://api.test.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'https://api.test.delfi.lt/weather/v1/graphql',
      WEATHER_API_URL: 'https://api.test.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || `https://lt-review-portal-root.s3.review.delfi.lt/${key.DEPLOY_PATH}`,
    },
    lt_production: {
      ORDERS_API_URL_SERVER: '',
      ORDERS_API_URL: '',
      ARTICLE_EXTRA_CONTENT_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/article_extra.php',
      ARTICLE_EXTRA_CONTENT_API_URL: 'https://www.delfi.lt/misc/pc/article_extra.php',
      CONFIG_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/config.php',
      CONFIG_API_URL: 'https://www.delfi.lt/misc/pc/config.php',
      FEED_API_URL_SERVER: 'https://www.delfi.lt/misc/pc/feed.php',
      FEED_API_URL: 'https://www.delfi.lt/misc/pc/feed.php',
      CONTENT_API_URL_SERVER: 'http://content-api-graphql.content-api/content/v2',
      CONTENT_API_URL_V3: 'https://api.delfi.lt/content/v3',
      CONTENT_API_URL_V3_SERVER: 'https://api.delfi.lt/content/v3',
      MEDIA_API_URL_SERVER: 'https://api.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_URL: 'https://api.delfi.lt/media-api-image-cropper/v1',
      MEDIA_API_DATA_URL_SERVER: 'https://api.delfi.lt/media/v1',
      MEDIA_API_DATA_URL: 'https://api.delfi.lt/media/v1',
      PAYWALL_API_URL_SERVER: 'http://paywall-api-internal.paywall-api/paywall/v1',
      PAYWALL_API_URL: 'https://api.delfi.lt/paywall/v1',
      LOGIN_API_URL_SERVER: 'http://login-api-v2-internal.login-api/login/v2',
      LOGIN_API_CLIENT_URL: 'https://lt-production-login-api-client.s3-website.teliahybridcloud.com/lt.js',
      LOGIN_APP_BASE_URL: 'https://g.delfi.lt/glt/c/delfi-login',
      PCC_API_URL_SERVER: '',
      CUSTOMER_DATA_API_URL: 'https://api.delfi.lt/customer-data/v2',
      WEATHER_API_URL_SERVER: 'https://api.delfi.lt/weather/v1/graphql',
      WEATHER_API_URL: 'https://api.delfi.lt/weather/v1/graphql',
      CDN_PUBLIC_PATH: process.env.CDN_PUBLIC_PATH || 'https://lt-production-portal-root.s3.delfi.lt',
    },
  },
};

const channelEnv = key.ENV_DEFAULT_KEY as keyof typeof apis.apisEndpoints;
const DEFAULT_CLIENT_CONFIG = apis.apisEndpoints[channelEnv];

export default DEFAULT_CLIENT_CONFIG;
